module.exports = __webpack_public_path__ + "assets/folder2.92c26088.svg";